import React from 'react';
import BackDateApprovalController from '../../../Controllers/AdminScreens/Invoices/BackDateApprovalController';
import Loader from '../../../../Components/Loader';
import TextInput from '../../../../Components/TextInput';
import DateInput from '../../../../Components/DateInput';
import Dropdown from '../../../../Components/Dropdown';
import { convertGMTToLocal } from '../../../../Utils/Validation';
import { useNavigate } from 'react-router-dom';
import filterIcon from '../../../../Assets/Icons/filter.png';
import leftBtuIcon from '../../../../Assets/Icons/back.png';
import leftArrowIcon from '../../../../Assets/Icons/chevron-down.png';
import search from '../../../../Assets/Icons/search.png';
import approveIcon from '../../../../Assets/Icons/Check circle-1.png'
import reject from '../../../../Assets/Icons/Plus circle.png'

const BackDateApprovalListScreen = ({ approvalList, loading, error, onRefresh }) => {
    const {
        currentTasks,
        currentPage,
        totalPages,
        visiblePages,
        handlePageChange,
        handleApprove,
        handleReject,
        updatingStatus,
        searchUser,
        handleSearchInputText,
        handleSearchClient,
        searchLoading,
        searchError,
        clientList,
        handleSelectClient,
        filterData,
        serviceListLoading,
        handleInputChange,
        openDropdown,
        toggleDropdown,
        dropdownRefs,
        serviceOptions,
        servicesLoading,
        servicesError,
        recipientOptions,
        userLoading,
        userError,
        showFilters,
        toggleFilters,
        applyFilters,
        cancelFilters,
        resetFilters,
        filterError,
        actionError,
        actionSuccess,
        serviceListError,
    } = BackDateApprovalController(approvalList, onRefresh, error);

    const navigate = useNavigate();

    const getStatusUI = (row) => {
        const status = row?.back_date_approval;
        if ([1, 21].includes(status)) {
            return (
                <span className="tasksScreen-status-badge new">
                    Pending
                </span>
            );
        } else if ([2, 22].includes(status)) {
            return (
                <span className="tasksScreen-status-badge completed">
                    Approved
                </span>
            );
        } else if ([3, 23].includes(status)) {
            return (
                <span className="tasksScreen-status-badge overdue">
                    Rejected
                </span>
            );
        } else {
            return '--';
        }
    };


    return (
        <>
            <div className='basic-info-container'>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h3 style={styles.categoryHeader}>Approvals</h3>
                </div>
                <div style={styles.container}>
                    <div style={styles.filtersHeader}>
                        <button style={styles.filterButton} onClick={toggleFilters}>
                            <img alt='Filter' src={filterIcon} style={styles.filterIcon} /> Filters
                        </button>
                        <div>
                            <img alt='Left Icon' src={leftBtuIcon} style={{ marginRight: '5px', cursor: 'pointer', width: '28px', height: '28px' }} />
                            <img alt='Right Icon' src={leftBtuIcon} style={{ transform: 'rotate(180deg)', cursor: 'pointer', width: '28px', height: '28px' }} />
                        </div>
                    </div>
                </div>

                {showFilters && (
                    <div className={`tasksScreen-filters-container ${showFilters ? 'tasksScreen-open-filters' : ''}`}>
                        <div className="tasksScreen-filters">
                            <div className="filter-field">
                                <label>Client Name</label>
                                <TextInput
                                    type="text"
                                    placeholder="Client Name"
                                    value={searchUser}
                                    onChange={(e) => handleSearchInputText(e.target.value)}
                                    onRightClick={handleSearchClient}
                                    right={
                                        searchLoading ? (
                                            <Loader loading={true} color={'var(--primary-loader-color)'} size='small' />
                                        ) : (
                                            <img src={search} alt="Search" style={{ height: '20px', width: '20px', cursor: 'pointer' }} />
                                        )
                                    }
                                    errorMessage={searchError}
                                />
                                {clientList.length > 0 && (
                                    <ul style={styles.dropdownList}>
                                        {clientList.map((client, index) => (
                                            <li key={index} onClick={() => handleSelectClient(client)} style={styles.dropdownItem}>
                                                {client.client_name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            <Dropdown
                                ref={(el) => (dropdownRefs.current["Services"] = el)}
                                isOpen={openDropdown === "Services"}
                                toggleDropdown={() => toggleDropdown("Services")}
                                label="Services"
                                options={serviceOptions}
                                value={filterData.services}
                                onChange={(value) => handleInputChange("services", value)}
                                loading={servicesLoading}
                                errorMessage={servicesError}
                            />

                            <div>
                                <label style={styles.label}>Generated Date</label>
                                <DateInput
                                    value={filterData.generatedDate}
                                    onChange={(e) => handleInputChange("generatedDate", e.target.value)}
                                />
                            </div>

                            <Dropdown
                                ref={(el) => (dropdownRefs.current["Generated By"] = el)}
                                isOpen={openDropdown === "Generated By"}
                                toggleDropdown={() => toggleDropdown("Generated By")}
                                label="Generated By"
                                options={recipientOptions}
                                value={filterData.generatedBy}
                                onChange={(value) => handleInputChange("generatedBy", value)}
                                loading={userLoading}
                                errorMessage={userError}
                            />
                        </div>
                        <div>
                            {filterError && <div className="list-error-msg" style={{ textAlign: 'left', paddingBottom: 5 }}> {filterError}</div>}
                            <div className="tasksScreen-filter-buttons">
                                <button onClick={applyFilters} className="tasksScreen-apply-button">Apply</button>
                                <button onClick={cancelFilters} className="tasksScreen-cancel-button">Cancel</button>
                                <button onClick={resetFilters} className="tasksScreen-reset-button">Reset</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="basic-info-card" style={{ border: 'none', padding: '0px' }}>
                <div style={styles.tableWrapper}>
                    <table className="tasksScreen-task-table">
                        <thead>
                            <tr>
                                <th style={{ width: "15%" }}>Invoice No.</th>
                                <th style={{ width: "15%" }}>Invoice Date</th>
                                <th style={{ width: "25%" }}>Client Name/Group Master</th>
                                <th style={{ width: "25%" }}>Username</th>
                                <th style={{ width: "15%" }}>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody style={{ backgroundColor: "white" }}>
                            {currentTasks?.map((item, index) => (
                                <tr key={index}>
                                    <td style={styles.tableLink} onClick={() => navigate('/generate-invoice', { state: { rowData: item, pageType: 'Approval', selectedTab: 4 } })}>
                                        {item?.invoice_id_gen}
                                    </td>
                                    <td>{convertGMTToLocal([21, 22, 23].includes(item?.back_date_approval) ? item?.invoice_date_new : item?.invoice_date, 'dd/MM/yyyy')}</td>
                                    <td>{item?.client_name || item?.group_name_client || '--'}</td>
                                    <td>{item?.invoice_gen_emp_name || '--'}
                                        {actionError[item?.invoice_id] &&
                                            <div style={{ color: 'red', paddingTop: 10 }} >{actionError[item?.invoice_id]}</div>}
                                        {actionSuccess[item?.invoice_id] &&
                                            <div style={{ color: 'green', paddingTop: 10 }} >{actionSuccess[item?.invoice_id]}</div>}
                                    </td>
                                    <td>{getStatusUI(item)}</td>
                                    <td>
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "2px", // Space between edit and delete buttons
                                                justifyContent:
                                                    (([1, 2, 21, 22].includes(item?.back_date_approval)) ? 1 : 0) +
                                                        (([1, 3, 21, 23].includes(item?.back_date_approval)) ? 1 : 0) === 1
                                                        ? "center"
                                                        : "flex-start",
                                            }}
                                        >
                                            {/* Approve Button */}
                                            {([1, 2, 21, 22].includes(item?.back_date_approval)) &&
                                                (
                                                    <button
                                                        className="tasksScreen-edit-button"
                                                        style={{
                                                            border: "none",
                                                            background: "transparent",
                                                            cursor: [2, 22].includes(item?.back_date_approval) || updatingStatus[item?.invoice_id] ? "not-allowed" : "pointer",
                                                            opacity: updatingStatus[item?.invoice_id] ? 0.5 : 1,
                                                        }}
                                                        disabled={[2, 22].includes(item?.back_date_approval) || updatingStatus[item?.invoice_id]}
                                                        onClick={() => handleApprove(item)}
                                                    >
                                                        {updatingStatus[item?.invoice_id] === 'approve' ? (
                                                            <Loader loading={true} color={'var(--primary-loader-color)'} size="small" />
                                                        ) : (
                                                            <img
                                                                src={approveIcon}
                                                                alt="Approve"
                                                                style={{ width: "18px", height: "18px" }}
                                                            />
                                                        )}
                                                    </button>
                                                )}

                                            {/* Reject Button */}
                                            {([1, 3, 21, 23].includes(item?.back_date_approval)) &&
                                                <button
                                                    className="tasksScreen-delete-button"
                                                    style={{
                                                        border: "none",
                                                        background: "transparent",
                                                        cursor: [3, 23].includes(item?.back_date_approval) || updatingStatus[item?.invoice_id] ? "not-allowed" : "pointer",
                                                        opacity: updatingStatus[item?.invoice_id] ? 0.5 : 1,
                                                    }}
                                                    disabled={[3, 23].includes(item?.back_date_approval) || updatingStatus[item?.invoice_id]}
                                                    onClick={() => handleReject(item)}
                                                >
                                                    {updatingStatus[item?.invoice_id] === 'reject' ? (
                                                        <Loader loading={true} color={'var(--primary-loader-color)'} size="small" />
                                                    ) : (
                                                        <img
                                                            src={reject}
                                                            alt="Reject"
                                                            style={{ width: "18px", height: "18px" }}
                                                        />
                                                    )}
                                                </button>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {loading && <Loader loading={loading} color={'var(--primary-loader-color)'} />}
                    {serviceListLoading && <Loader loading={serviceListLoading} color={'var(--primary-loader-color)'} />}
                    {/* {error && <div className="list-error-msg">{error}</div>} */}
                    {serviceListError && <div className="list-error-msg"> {serviceListError}</div>}
                </div>
            </div>
            <hr className="divider" style={{ marginTop: '20px' }} />
            <div className="table-footer">
                <div className="total-count"></div>
                <div className="pagination">
                    <div className="pagination-info">{`${currentPage}-${totalPages} of items`}</div>
                    <button className="pagination-button-arrow" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        <img src={leftArrowIcon} alt="Previous" className="tasksScreen-arrow-left" style={{ width: '17px', height: '17px' }} />
                    </button>
                    {visiblePages.map((page) => (
                        <button
                            key={page}
                            className={`tasksScreen-pagination-button ${currentPage === page ? 'active' : ''}`}
                            onClick={() => handlePageChange(page)}
                        >
                            {page}
                        </button>
                    ))}
                    <button className="pagination-button-arrow" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        <img src={leftArrowIcon} alt="Next" className="tasksScreen-arrow-right" style={{ width: '17px', height: '17px' }} />
                    </button>
                </div>
            </div>
        </>
    );
};

const styles = {
    categoryHeader: {
        color: '#1F384C',
        fontSize: 18,
        fontFamily: 'Roboto Slab',
        fontWeight: 500,
        paddingBottom: 20
    },
    tableWrapper: {
        overflowX: 'auto'
    },
    tableLink: {
        textDecoration: 'underline',
        color: '#5A55D2',
        cursor: 'pointer'
    },
    label: {
        fontSize: '12px',
        color: '#343C44'
    },
    filterButton: {
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px var(--button-bg-color) solid",
        borderRadius: "20px",
        padding: "5px 8px",
        fontSize: '12px',
        fontWeight: '400',
        fontFamily: 'Roboto',
        cursor: 'pointer'
    },
    filterIcon: {
        width: '10px',
        height: '10px',
        paddingRight: '5px'
    },
    filtersHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    container: {
        padding: "5px",
        backgroundColor: "#EFF0F4",
        border: "1px #EFF0F4 solid"
    },
    dropdownList: {
        position: 'absolute',
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        listStyleType: 'none',
        padding: 0,
        margin: 0,
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
    },
};

export default BackDateApprovalListScreen;
